import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],
 template: ''
})
export class ActivityPage{
 sessionToken = '';
  whatsAppUrl = environment.whatsapp_url;
  constructor(private route: ActivatedRoute, 
              private router: Router) {}
  ngOnInit() {
    this.sessionToken = this.route.snapshot.paramMap.get('token') ?? '';
    if (!this.sessionToken) {
        window.location.href = this.whatsAppUrl;
      return;
    }
    this.router.navigateByUrl(
        '/ViewAccount/' + this.sessionToken,
        { replaceUrl: true }
        );
  }
 
}